/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext, useState } from "react";
import CommonContext from "../../../hooks/commonContext";
import {
  Container,
  TextField,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@material-ui/core";
import { CheckCircle, XCircle, Filter, Search } from "lucide-react";
import PageTitle from "../../../components/pageTitle/PageTitle";
import ThemeTable from "../../../components/Table/ThemeTable";
import { Columns } from "./suppliesTableColumns";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import { Badge } from "../../../components/ui/badge";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import CloseIcon from "@mui/icons-material/Close";
import { Search as SearchIcon } from "@mui/icons-material";
import {
  getSupplyOrderList,
  updateSuppliesStatus,
  supplyRejectReasons,
  getCategories,
  updateSupplyItemsStatus,
} from "../../../services/apiservices/supplies";
import SingleSelect from "../../../components/SelectField/SingleSelect";
import { FormatedDates } from "../../../services/helpers";
import ConfirmationDialog from "../../../components/DialogComponent/ConfirmationDialog";
import { getClientsListbasedonIds } from "../../../services/apiservices/client";
import { getEmployeesListBasedOnId } from "../../../services/apiservices/employee";
import { saveNotification2 } from "../../../services/apiservices/notifications";
import AuthContext from "../../../hooks/authContext";
import { useMediaQuery } from "@mui/material";
import {
  SuppplyDataDialog,
  CommonConfirmationDialog,
  CommonSuccessDialog,
} from "../../../components/DialogComponent/SupplyDataDialog";
import { getSettings } from "../../../services/apiservices/settings";
import { DOMAINURL_SUPPIESEMAIL } from "../../../services/config";
import { Card, CardContent } from "../../../components/ui/card";
import { useToast } from "../../../hooks/useToast";
import { Input } from "../../../components/ui/input";
import SingleSelectNew from "../../../components/SelectField/SingleSelectNew";

const Supplies = (props) => {
  const commonContext = useContext(CommonContext);
  const auth = useContext(AuthContext);
  const [allSupplies, setAllSupplies] = React.useState([]);
  const [filteredList, setFilteredList] = React.useState([]);
  const [recordID, setRecordID] = useState();
  const [selectedReason, setSelectedReason] = useState("");
  const [reasonMessage, setReasonMessage] = useState("");
  const [alertOpen, setAlertOpen] = useState(false);
  const [data, setData] = useState();
  const [empData, setEmpData] = useState();
  const [categoryMap, setCategoryMap] = useState({});
  const [dialogOpenSucces, setDialogOpenSucces] = useState(false);
  const [dialogOpenReject, setDialogOpenReject] = useState(false);
  const [dialogConfirmOpen, setDialogConfirmOpen] = useState(false);
  const [opens, setOpens] = useState(null);
  const [openSupplyDialog, setOpenSupplyDialog] = useState(false);
  const [openData, setOpenData] = useState(null);
  const isMobile = useMediaQuery("(max-width:767px)");
  const isLandscape = useMediaQuery(
    "(min-width: 771px) and (max-width: 940px)"
  );
  const [detailsDialogOpen, setDetailsDialogOpen] = useState(false);
  const [currentRequest, setCurrentRequest] = useState(null);
  const [expanded, setExpanded] = useState(null);
  const [searchTerm, setsearchTerm] = React.useState("");
  const [settingsData, setSettingsData] = useState();
  const [isLoading, setIsLoading] = React.useState(false);
  const companyId =
    auth?.userProfile?.role === "companyUser"
      ? auth?.userProfile?.id
      : auth?.userProfile?.companyId;
  // const [recPerPage, setRecordsPerPage] = React.useState(10);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const { toast } = useToast();

  const checkRowSearch = (searchTerm, row) => {
    const term = searchTerm.toLowerCase();
    return (
      row.status?.toLowerCase().includes(term) ||
      row.clientName?.toLowerCase().includes(term) ||
      row.employeeName?.toLowerCase().includes(term)
    );
  };

  const checkFilteredList = () => {
    if (allSupplies && Array.isArray(allSupplies)) {
      const filteredSuppliesList = allSupplies?.filter((row) => {
        return searchTerm ? checkRowSearch(searchTerm, row) : true;
      });
      setFilteredList(filteredSuppliesList);
    }
  };

  useEffect(() => {
    checkFilteredList();
  }, [allSupplies, searchTerm]);


  const fetchSuppliesList = () => {
    try {
      setIsLoading(true);

    return getSupplyOrderList(
        { companyId, status: "Pending" },
        async (supplyResponse) => {
          try {
            const records = supplyResponse || [];

      if (records.length === 0) {
        auth.resetPendingSupplyStatus();
        setAllSupplies([]);
        setEmpData([]);
        setIsLoading(false);
        return;
      }

      auth.setPendingSupplyStatus(records);

      const clientIds = [...new Set(records.map((o) => o.clientId))];
      const empIds = [...new Set(records.map((o) => o.createdBy))];

      const [clientsResult, employeesResult, categoriesResponse] =
       await Promise.all([
        new Promise((resolve) =>
          getClientsListbasedonIds(clientIds, (data) => resolve(data?.length ? data : []))),
        new Promise((resolve) =>
          getEmployeesListBasedOnId(empIds, (data) => resolve(data?.length ? data : []))),
        new Promise((resolve) => getCategories(companyId, resolve)),
      ]);

      const clientMap = new Map(
        clientsResult?.map((item) => [item.id, item.clientName])
      );
      const empMap = new Map(
        employeesResult?.map((item) => [
          item.userId,
          {
            label: `${item.firstName} ${item.lastName}`,
            email: item.email,
          },
        ])
      );

      const newRows = records.map((ritem) => {
        const totalQuantity = ritem?.supplyItems?.reduce((sum, item) => sum + (item.qty || 0), 0) || 0;

        const employee = empMap.get(ritem.createdBy);
        const clientName = clientMap.get(ritem.clientId);

        return {
          ...ritem,
          orderId: String(ritem?.orderNumber).padStart(6, "0"),
          supplies: `(${totalQuantity})`,
          employeeName: employee?.label || "Unknown employee",
          clientName: clientName || "Unknown Client",
          dateOfRequest: ritem?.dateOfRequest,
        };
      });

      const sortedData = sortingFunction(newRows);

      await fetchAndStoreCategories(sortedData, categoriesResponse);
      setAllSupplies(sortedData);

      setEmpData(
        employeesResult?.map((item) => ({
          value: item.userId,
          label: `${item.firstName} ${item.lastName}`,
          email: item.email,
        }))
      );

      setIsLoading(false);
    } catch (error) {
      console.error("Error processing supplies:", error);
      setIsLoading(false);
      }
    },
    (err) => {
      console.error("subscribeToSupplyOrderList error:", err);
      setIsLoading(false);
      }
    );
    } catch (error) {
      console.error("Error setting up supplies subscription:", error);
      setIsLoading(false);
      return () => {};
    }
  };

  useEffect(() => {
  let unsubscribeSupplies;

    const init = async () => {
      try {
        unsubscribeSupplies = fetchSuppliesList();

        getSettings("supplie_settings", (res) => {
          if (res?.data?.length > 0) {
            const filteredData = res?.data?.filter(
              (item) => item?.companyId === companyId && !item.deleted
            );
            setSettingsData(filteredData?.[0] || null);
          } else {
            setSettingsData(null);
          }
        });
      } catch (error) {
        console.error("Initialization error:", error);
      }
    };

    init();

    return () => {
      if (typeof unsubscribeSupplies === "function") {
        unsubscribeSupplies();
      }
    };
  }, []);

  const sortingFunction = (data) => {
    const result = data?.sort((a, b) => {
      if (a.orderId < b.orderId) return -1;
      if (a.orderId > b.orderId) return 1;

      if (a.employeeName < b.employeeName) return -1;
      if (a.employeeName > b.employeeName) return 1;

      return 0;
    });

    return result;
  };

  const fetchAndStoreCategories = async (latestData, categoriesData) => {
    const newCategoryMap = {};

    const categoryLookup = new Map();
    for (const cat of categoriesData) {
      if (cat?.id) {
        categoryLookup.set(cat.id, cat.title);
      }
    }

    for (const item of latestData) {
      const { id: mainId, supplyItems } = item;
      if (supplyItems?.length) {
        const categoriesForItem = [];

        for (const { parentCategoryId } of supplyItems) {
          if (parentCategoryId) {
            const title = categoryLookup.get(parentCategoryId);
            if (title) {
              categoriesForItem.push({
                parentCategoryId,
                title,
              });
            }
          }
        }

        newCategoryMap[mainId] = categoriesForItem;
      }
    }

    setCategoryMap(newCategoryMap);
  };

  const sendRejectNotification = async () => {
    let name;
    let email;
    const orderId = data ? data.orderId : null;
    const clientName = data ? data.clientName : null;
    const companyName = `${auth?.userProfile?.companyData?.data?.companyName}`
    const supply = true;

    const employee = empData?.find((emp) => emp.value === data.createdBy && emp.status !== false);
    if (!employee) return;
      name = employee?.label;
      email = employee?.email;

    let updatedTitles = [];
    const category = categoryMap[data.id];
    if (category) {
      updatedTitles = data?.supplyItems?.map((supplyItem, index) => {
        const categoryItem = category?.find(
          (cat) => cat.parentCategoryId === supplyItem.parentCategoryId
        );
        const title = categoryItem
          ? `${categoryItem.title} - ${supplyItem.title}`
          : `${supplyItem.title}`;
        return `${index + 1}. ${title} (${supplyItem.qty})`;
      });
    }

    const updatedTitlesStr = updatedTitles.join("\n");
    const link = `https://${DOMAINURL_SUPPIESEMAIL}/Supplies/${data.id}`;
    const notifications = [
      {
        Type: "PushNotification",
        Message: `Your supply request OrderID ${data.orderId} has been cancelled. Please check your email.`,
        read: false,
        companyId: companyId,
        extData: { type: "Supplies", id: data?.id },
        Employee: [
          {
            id: data?.createdBy,
            name: data?.employeeName,
            email: email,
          },
        ],
      },
      {
        Type: "Email",
        Message: `Your supply request OrderId ${data.orderId} has been canceled by the support team.<br>
          Please contact us to resubmit a new request or discuss this order with your support team.<br>
          Details:\n 
          ${updatedTitlesStr}<br><br>
          <p>To respond to this message, please click <a href="${link}" target="_blank">here</a> to open the issue the <span style="white-space: nowrap;">ProTeams app.</p><br>
          ProTeams Support Team`,
        read: false,
        companyId: companyId,
        Employee: [
          {
            id: data?.createdBy,
            name: name,
            email: email,
          },
        ],
      },
    ];

    await saveNotification2(notifications, supply, orderId, clientName, companyName);
  };

  const sendApproveNotification = async () => {
    let name;
    let email;
    const orderId = data ? data.orderId : null;
    const clientName = data ? data.clientName : null;
    const companyName = `${auth?.userProfile?.companyData?.data?.companyName}`
    const supply = true;

    const employee = empData?.find((emp) => emp?.value === data?.createdBy && emp?.status !== false);
    if (!employee) return;
      name = employee?.label;
      email = employee?.email;

    let updatedTitles = [];
    const category = categoryMap[data.id];
    if (category) {
      updatedTitles = data?.supplyItems?.map((supplyItem, index) => {
        const categoryItem = category?.find(
          (cat) => cat.parentCategoryId === supplyItem.parentCategoryId
        );
        const title = categoryItem
          ? `${categoryItem.title} - ${supplyItem.title}`
          : `${supplyItem.title}`;
        return `${index + 1}. ${title} (${supplyItem.qty})`;
      });
    }

    const updatedTitlesStr = updatedTitles.join("\n");
    const link = `https://${DOMAINURL_SUPPIESEMAIL}/Supplies/${data.id}`;
    const notifications = [
      {
        Type: "PushNotification",
        Message: `Your supply request OrderID ${data.orderId} has been approved. Please check your email.`,
        read: false,
        companyId: companyId,
        extData: { type: "Supplies", id: data?.id },
        Employee: [
          {
            id: data?.createdBy,
            name: data?.employeeName,
            email: email,
          },
        ],
      },
      {
        Type: "Email",
        Message: `Your supply request OrderId ${data?.orderId} has been approved by the support team.<br>
          Details:\n 
          ${updatedTitlesStr}<br><br>
          <p>To respond to this message, please click <a href="${link}" target="_blank" style="color: #0066cc; text-decoration: underline;">here</a> to open the issue the <span style="white-space: nowrap;">ProTeams</span> app.</p><br>
          ProTeams Support Team`,
        read: false,
        companyId: companyId,
        Employee: [
          {
            id: data?.createdBy,
            name: name,
            email: email,
          },
        ],
      },
    ];

    await saveNotification2(notifications, supply, orderId, clientName, companyName);
  };

  const handleDialogOpen = (item) => {
    setSelectedItem(item);
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setSelectedItem(null);
    setSelectedReason("");
    setReasonMessage("");
  };

  const handleProceed = async () => {
    if (!selectedReason && !reasonMessage) {
      setAlertOpen(true);
      return;
    }

    const result = {
      reason: selectedReason,
      message: reasonMessage,
    };

    commonContext?.setLoader(true);

    try {
      const formData = {
        status: "Rejected",
      };
      const name = `${auth?.userProfile?.firstName} ${auth?.userProfile?.lastName}`;  
      const promises = [
        supplyRejectReasons(recordID, result),
        updateSuppliesStatus(recordID, formData, name),
        updateSupplyItemsStatus(recordID, "Cancel Item"),
        sendRejectNotification(),
      ];

      handleDialogClose();

      await Promise.all(promises);

      setSelectedReason("");
      setReasonMessage("");
      commonContext?.setLoader(false);
      setDialogOpenReject(true);
    } catch (error) {
      console.error("Error handling proceed:", error);
    }
  };

  const handleViewDetails = (request) => {
    setCurrentRequest(request);
    setDetailsDialogOpen(true);
  };

  const approvedClick = async (id) => {
    setDialogConfirmOpen(false);
    const formData = {
      status: "Approved",
    };
    const name = `${auth?.userProfile?.firstName} ${auth?.userProfile?.lastName}`;
    await Promise.all([
      updateSuppliesStatus(id, formData, name),
      sendApproveNotification()
    ]);
    setSelectedItem(null);
    setDialogOpenSucces(true);
  };

  const handelApproveClick = async (id) => {
    setDialogConfirmOpen(true);
    setSelectedItem(id);
  };

  const handleDialogConfirmClose = () => {
    setDialogConfirmOpen(false);
    setSelectedItem(null);
  };

  const handleCloseSuccesDialog = async () => {
    setDialogOpenSucces(false);
    await fetchSuppliesList();
    toast?.({title: "Success", description: "Order Request Approved Successfully"});
  };
  const handleCloseRejectDialog = async () => {
    setDialogOpenReject(false);
    await fetchSuppliesList();
    toast?.({title: "Success", description: "Order Request Rejected Successfully"});
  };

  const handleDialogSupplyOpen = async (data) => {
    setOpenSupplyDialog(true);
    setOpenData(data);
  };

  const handleDialogSupplyClose = async () => {
    setOpenSupplyDialog(false);
    setOpenData(null);
  };

  const getPriorityBadgeVariant = (priority) => {
    switch (priority) {
      case "1":
        return "danger";
      case "2":
        return "warning";
      case "3":
        return "info";
      default:
        return "secondary";
    }
  };

  const getPriorityLabel = (priority) => {
    switch (priority) {
      case "1":
        return "High";
      case "2":
        return "Medium";
      case "3":
        return "Low";
      default:
        return "Unknown";
    }
  };

  const renderRowCell = (rcellItem, hcellItem, index, rowindex) => {
    switch (hcellItem.id) {
      case "orderId":
        return (
          <span
            style={{fontSize: "14px", fontWeight: "600" }}
          >
            {rcellItem?.orderId}
          </span>
        );
      case "dateOfRequest":
        return FormatedDates(rcellItem?.dateOfRequest);
      case "priority":
        return (
          <Badge variant={getPriorityBadgeVariant(rcellItem?.priority)}>
            {getPriorityLabel(rcellItem.priority)}
          </Badge>
        );
      case "supplies":
        return (
          <>
            <Button
              variant="link"
              className="p-0 h-auto"
              style={{ color: "green" }}
              onClick={() => handleViewDetails(rcellItem)}
            >
              View {rcellItem?.supplies}
            </Button>
          </>
        );
      case "action":
        return (
          <>
            <IconButton
              style={{
                color: settingsData ? !settingsData.approveRequestRole?.some((r) => Array.isArray(auth?.userProfile?.role) ? auth.userProfile.role.includes(r) : auth.userProfile.role === r)
                    ? "gray"
                    : "green"
                  : "green",
              }}
              onClick={() => {handelApproveClick(rcellItem?.id); setRecordID(rcellItem?.id); setData(rcellItem);}}
              disabled={settingsData ? !settingsData.approveRequestRole?.some((r) => Array.isArray(auth?.userProfile?.role) ? auth.userProfile.role.includes(r) : auth.userProfile.role === r): false}
            >
              <CheckCircleOutlinedIcon />
            </IconButton>
            <IconButton
              style={{
                color: settingsData ? !settingsData.approveRequestRole?.some((r) => Array.isArray(auth?.userProfile?.role) ? auth.userProfile.role.includes(r) : auth.userProfile.role === r)
                    ? "gray"
                    : "red"
                  : "red",
              }}
              onClick={() => {
                handleDialogOpen(rcellItem?.id);
                setRecordID(rcellItem?.id);
                setData(rcellItem);
              }}
              disabled={settingsData ? !settingsData.approveRequestRole?.some((r) => Array.isArray(auth?.userProfile?.role) ? auth.userProfile.role.includes(r) : auth.userProfile.role === r): false}
            >
              <CancelOutlinedIcon />
            </IconButton>
          </>
        );

      default:
        return rcellItem[hcellItem?.id];
    }
  };

  return (
    <>
      <Container>
        <PageTitle
          pageTitle="Supply Requests"
          showBreadcrumb={[{ label: "Home", to: "/" }]}
          // showLastSeen={true}
        />
        <div className={isMobile ? "pv-20 ph-10" : "pv-24 ph-32"}>
          <div className="p-4 md:p-6 space-y-4">
            <div className="bg-white dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] rounded-md shadow-sm p-20 mb-6">
              <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center">
                <div className="flex flex-col mb-4 sm:mb-0">
                  <p className="text-sm text-slate-500">
                    Manage pending supply requests
                  </p>
                </div>
                <div
                  className="d-flex flex-center relative mb-4"
                  style={{
                    width: "100%",
                    maxWidth: "400px",
                  }}
                >
                  <Search
                    className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500"
                    size={18}
                  />
                  <Input
                    fullWidth
                    size="small"
                    name="searchTerm"
                    className="pl-40 bg-white dark:bg-[#0F1729]"
                    id="searchTerm"
                    placeholder="Search requests..."
                    variant="outlined"
                    value={searchTerm}
                    onChange={(e) => setsearchTerm(e.target.value)}
                    InputProps={{
                      style: { paddingLeft: 36 },
                    }}
                  />
                   <Button variant="outlined" size="icon" className="ml-10" style={{height:"40px"}}>
                    <Filter className="h-4 w-4 dark:text-white" />
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div
            className={`sectionBox2 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}
            style={{
              // border: "1px solid hsl(214.3, 31.8%, 91.4%)",
              // borderRadius: "8px",
            }}
          >
            {!isMobile && !isLandscape && (
              <ThemeTable
                rows={filteredList}
                headCells={Columns}
                hidePagination={false}
                isLoading={isLoading}
                renderRowCell={renderRowCell}
                // selectedRows={selectedRows}
              />
            )}
            {(isMobile || isLandscape) && (
              <>
                {filteredList?.map((request, index) => {
                  return (
                    <Card
                      key={request?.id}
                      className="overflow-hidden w-100 mb-15"
                    >
                      <div className="p-15">
                        <div className="flex justify-between items-start">
                          <div>
                            <p className="font-semibold text-sm">
                              {request?.orderId}
                            </p>
                            <p className="text-sm text-muted-foreground">
                              {FormatedDates(request?.dateOfRequest)}
                            </p>
                          </div>
                          <Badge
                            variant={getPriorityBadgeVariant(request?.priority)}
                          >
                            {getPriorityLabel(request?.priority)}
                          </Badge>
                        </div>
                      </div>
                      <div className="border-b"></div>

                      <CardContent className="p-16">
                        <div className="p-4 space-y-3">
                          <div className="flex justify-between">
                            <span className="text-sm font-medium">
                              Employee:
                            </span>
                            <span className="text-sm">
                              {request?.employeeName}
                            </span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-sm font-medium">Client:</span>
                            <span className="text-sm">
                              {request?.clientName}
                            </span>
                          </div>
                          <div className="flex justify-between">
                            <span className="text-sm font-medium">Items:</span>
                            <span
                              className="text-sm text-blue-500 cursor-pointer"
                              onClick={() => handleViewDetails(request)}
                            >
                              View {request?.supplies}
                            </span>
                          </div>
                        </div>
                      </CardContent>
                      <div className="flex border-t">
                        <Button
                          variant="ghost"
                          className="flex-1 rounded-none border-r hover:bg-green-50 hover:text-green-600 py-2 h-12 dark:text-green-600"
                          style={{
                            borderRight: "1px solid hsl(214.3, 31.8%, 91.4%)",
                          }}
                          onClick={() => { handelApproveClick(request?.id); setRecordID(request?.id); setData(request); }}
                        >
                          <CheckCircle className="mr-2 h-4 w-4 dark:text-green-600" />
                          Approve
                        </Button>
                        <Button
                          variant="ghost"
                          className="flex-1 rounded-none hover:bg-red-50 hover:text-red-600 py-2 h-12 dark:text-red-600"
                          onClick={() => {
                            handleDialogOpen(request?.id);
                            setRecordID(request?.id);
                            setData(request);
                          }}
                        >
                          <XCircle className="mr-2 h-4 w-4 dark:text-red-600" />
                          Reject
                        </Button>
                      </div>
                    </Card>
                  );
                })}
              </>
            )}
          </div>
        </div>
      </Container>
      {dialogOpen && (
        <ConfirmationDialog
          show={dialogOpen}
          title="Reason to Reject Supply"
          confirmation={
            <>
              <SingleSelectNew
                select
                label="Reason"
                fullWidth
                margin="normal"
                contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                value={selectedReason}
                onChange={(e) => setSelectedReason(e)}
                options={[
                  { label: "Recent Shipment", value: "Recent Shipment" },
                  { label: "Duplicate Request ", value: "Duplicate Request" },
                  { label: "Contact Management", value: "Contact Management" },
                ]}
                zIndex={9999}
              />
              <Input
                fullWidth
                multiline={true}
                label="Reason Message"
                variant="outlined"
                placeholder="Reason Message"
                className="mt-10"
                rows={3}
                margin="normal"
                value={reasonMessage}
                onChange={(e) => setReasonMessage(e.target.value)}
              />
            </>
          }
          proceed={handleProceed}
          dismiss={handleDialogClose}
          cancel={handleDialogClose}
        />
      )}

      <Dialog open={alertOpen} onClose={() => setAlertOpen(false)}>
        <DialogTitle>Missing Information</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please provide a reason or a message before proceeding.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAlertOpen(false)} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
      {dialogConfirmOpen && (
        <CommonConfirmationDialog
          open={dialogConfirmOpen}
          onConfirm={() => approvedClick(selectedItem)}
          onClose={handleDialogConfirmClose}
          message="Are you sure you want to approve this request?"
          title="Confirm Approval"
          buttonTitle="Confirm"
        />
      )}
      <CommonSuccessDialog
        open={dialogOpenSucces}
        onClose={handleCloseSuccesDialog}
        title="Success"
        message="The order has been approved and is in process. Please review in Manage Supplies."
      />
      <CommonSuccessDialog
       open={dialogOpenReject} 
       onClose={handleCloseRejectDialog} 
       title="Success"
       message="The order has been rejected and has been added to Archived Orders."
       />
      <SuppplyDataDialog
        open={openSupplyDialog}
        onClose={handleDialogSupplyClose}
        listData={openData}
      />

      <Dialog open={detailsDialogOpen} onOpenChange={setDetailsDialogOpen}>
        <div className="d-flex flex-space-between flex-center dark:bg-[#1A1F2C] p-10">
          <div
          className="text-[#020817] dark:text-white"
            style={{ fontSize: "16px", fontWeight: "600" }}
          >
            Supply Request Details
          </div>
          <CloseIcon
            style={{ color: "red" }}
            onClick={() => setDetailsDialogOpen(false)}
          />
        </div>
        <DialogContent className="sm:max-w-md pb-15 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
          {currentRequest && (
            <div className="space-y-4">
              <div className="grid grid-cols-2 gap-8">
                <div style={{ width: "140px" }}>
                  <p className="text-sm text-muted-foreground">Order ID</p>
                  <p className="font-medium text-[#020817] dark:text-white">{currentRequest?.orderId}</p>
                </div>
                <div style={{ width: "140px" }}>
                  <p className="text-sm text-muted-foreground">Date</p>
                  <p className="font-medium text-[#020817] dark:text-white">
                    {FormatedDates(currentRequest?.dateOfRequest)}
                  </p>
                </div>
                <div style={{ width: "140px" }}>
                  <p className="text-sm text-muted-foreground">Employee</p>
                  <p className="font-medium text-[#020817] dark:text-white">{currentRequest?.employeeName}</p>
                </div>
                <div style={{ width: "140px" }}>
                  <p className="text-sm text-muted-foreground">Client</p>
                  <p className="font-medium text-[#020817] dark:text-white">{currentRequest?.clientName}</p>
                </div>
              </div>

              <div className="mt-30">
                <p className="text-sm font-medium text-[#020817] dark:text-white mb-10">Supply Items</p>
                <div className="border rounded-md divide-y mb-5">
                  {currentRequest?.supplyItems?.map((item, index) => (
                    <div key={index} className="p-3 flex justify-between mb-5">
                      <span className="font-medium text-[#020817] dark:text-[#6B7280]">{item.title}</span>
                      <span className="font-medium text-[#020817] dark:text-white">{item.qty}x</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
export default Supplies;
